// Quick-assign popover: click any owner avatar to reassign or unassign.

import { useEffect, useRef, useState } from "react";
import { useAppData } from "../store";
import { Avatar } from "./Primitives";
import { Ic } from "./Icon";

interface Props {
  anchor: DOMRect;
  currentOwner: string | null;
  onPick: (ownerId: string | null) => void;
  onClose: () => void;
}

export function OwnerPopover({ anchor, currentOwner, onPick, onClose }: Props) {
  const { data } = useAppData();
  const ref = useRef<HTMLDivElement>(null);
  const [q, setQ] = useState("");

  useEffect(() => {
    const onDoc = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) onClose();
    };
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("mousedown", onDoc);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDoc);
      document.removeEventListener("keydown", onKey);
    };
  }, [onClose]);

  if (!data) return null;
  const team = data.config.team.filter(
    (m) => m.status !== "disabled"
      && (!q || m.name.toLowerCase().includes(q.toLowerCase())),
  );

  const w = 260;
  let left = anchor.left;
  if (left + w + 12 > window.innerWidth) left = window.innerWidth - w - 12;
  const top = anchor.bottom + 6;

  return (
    <div
      ref={ref}
      style={{
        position: "fixed", top, left, width: w, zIndex: 250,
        background: "var(--surface)", borderRadius: 10,
        boxShadow: "var(--shadow-pop)", padding: 4,
      }}
    >
      <div className="input search" style={{ margin: 4 }}>
        <Ic name="search" size={13} />
        <input
          autoFocus placeholder="Assign to…"
          value={q} onChange={(e) => setQ(e.target.value)}
        />
      </div>
      <div style={{ maxHeight: 240, overflowY: "auto" }}>
        {team.map((m) => (
          <div
            key={m.id}
            onClick={() => onPick(m.id)}
            style={{
              padding: "7px 10px", borderRadius: 5, cursor: "pointer",
              display: "flex", alignItems: "center", gap: 9, fontSize: 13,
              background: currentOwner === m.id ? "var(--bg)" : "transparent",
            }}
          >
            <Avatar id={m.id} size="sm" />
            <span style={{ flex: 1 }}>{m.name}</span>
            <span style={{ color: "var(--ink-3)", fontSize: 11 }}>{m.role}</span>
          </div>
        ))}
      </div>
      <div
        style={{
          borderTop: "1px solid var(--border)", padding: "8px 12px",
          cursor: "pointer", color: "var(--ink-3)", fontSize: 12.5,
        }}
        onClick={() => onPick(null)}
      >Unassign</div>
    </div>
  );
}
